import { SearchProps, SearchPropType } from '~components/form-fields/search/props';

export const prepareSearchParam = (type: SearchPropType, field: string | string[], value: any) => {
  switch (type) {
    case 'text-like': {
      if (field instanceof Array) {
        return {
          or: buildParam(field, { like: `%${value}%` }),
        };
      }
      return buildParam(field, { like: `%${value}%` });
    }
    case 'multi-lookup': {
      if (!(field instanceof Array)) {
        return {
          [field]: value,
        };
      }
      return {
        or: buildParam(field, value),
      };
    }
    case 'time-range': {
      const result: { gte?: string; lte?: string } = {};
      if (value?.gte?.length > 0) result.gte = `${value.gte}`;
      if (value?.lte?.length > 0) result.lte = `${value.lte}`;
      return buildParam(field, result);
    }
    case 'date-range': {
      const result: { gte?: string; lte?: string } = {};
      if (value?.gte?.length > 0) result.gte = value.gte;
      if (value?.lte?.length > 0) result.lte = value.lte;
      return buildParam(field, result);
    }
    case 'lookup-like': {
      return buildParam(field, { like: `%${value}%` });
    }
    default: {
      return buildParam(field, value);
    }
  }
};

const buildParam = (field: string | string[], value: any) => {
  const param: { [key: string]: any } = {};
  if (field instanceof Array) {
    field.forEach((key) => {
      param[key] = value;
    });
  } else param[field] = value;
  return param;
};

export const formatFormikInitialValues = ({
  fields,
  initialValues,
}: {
  fields: SearchProps;
  initialValues: Record<string, any>;
}) => {
  return Object.keys(fields).reduce(
    (values, key) => {
      const { field, type } = fields[key];
      if (field && !(field instanceof Array)) {
        let value = initialValues[field];
        switch (type) {
          case 'lookup-like':
          case 'text-like': {
            if (value && typeof value === 'object' && typeof value.like === 'string') {
              value = value.like.replace(/^%|%$/g, '');
            }
            break;
          }
          default: {
            break;
          }
        }
        values[key] = value ?? '';
      }
      return values;
    },
    {} as Record<string, any>,
  );
};
